export class HandlebarsCache {
    static Instance;

    // handlebars;
    objectCaches = {};

    constructor(Handlebars) {
        // this.handlebars = Handlebars;
        // window.Handlebars = Handlebars;
        HandlebarsCache.Instance = this;
    }

    addToCache(type, key, object) {
        if(!this.objectCaches.hasOwnProperty(type))
            this.objectCaches[type] = {};
        this.objectCaches[type][key] = object;
    }

    getFromCache(type, key) {
        if(this.objectCaches.hasOwnProperty(type) && this.objectCaches[type].hasOwnProperty(key)) {
            return this.objectCaches[type][key];
         }
         return {};
    }
}